import { createAction, props } from '@ngrx/store';

import { Maintenance, StatusType } from '@vi-iot/client';

export namespace StatusPageActions {
  export enum Type {
    GET_STATUS_WITHOUT_TIMER = '[STATUS] Get status without timer',
    GET_STATUS = '[STATUS] Get status',
    GET_STATUS_ERROR = '[STATUS] Get status error',
    GET_STATUS_SUCCESS = '[STATUS] Get status success',
    GET_MAINTENANCES = '[STATUS] Get scheduled maintenances',
    GET_MAINTENANCES_SUCCESS = '[STATUS] Get scheduled maintenances success',
    GET_MAINTENANCES_ERROR = '[STATUS] Get scheduled maintenances error',
  }

  export const getStatus = createAction(Type.GET_STATUS);

  export const getStatusSuccess = createAction(
    Type.GET_STATUS_SUCCESS,
    props<{
      status: StatusType;
    }>()
  );

  export const getStatusError = createAction(
    Type.GET_STATUS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getStatusWithoutTimer = createAction(Type.GET_STATUS_WITHOUT_TIMER);

  export const getStatusWithoutTimerSuccess = createAction(
    Type.GET_STATUS_SUCCESS,
    props<{
      status: StatusType;
    }>()
  );

  export const getStatusWithoutTimerError = createAction(
    Type.GET_STATUS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getMaintenances = createAction(Type.GET_MAINTENANCES);

  export const getMaintenancesSuccess = createAction(
    Type.GET_MAINTENANCES_SUCCESS,
    props<{
      maintenances: Maintenance[];
    }>()
  );

  export const getMaintenancesError = createAction(Type.GET_MAINTENANCES_ERROR);
}
